module.exports = __webpack_public_path__ + "static/media/AppStore.5a513b23.svg";